// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsPage_container__3_pm_"};